import PropTypes from 'prop-types';
import CmsModules from 'libs/storyblok/content/Modules';
import { styled } from '@activebrands/core-web/libs/styletron';

const Wrapper = styled('div', {
    marginBottom: '40px',
    height: 'calc(var(--vh) - var(--height-header))',
});

const EmptyCheckoutView = ({ content = {} }) => {
    const { emptyContent = [] } = content;

    return (
        <Wrapper>
            <CmsModules isHero modules={emptyContent} />
        </Wrapper>
    );
};

EmptyCheckoutView.propTypes = {
    content: PropTypes.object.isRequired,
};

export default EmptyCheckoutView;
